// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"q2-z","sponsoredTooltipWrapper":"r2-z","sponsoredTooltip":"s2-z","newCard":"t2-z"};